import React from "react";
import { Grid } from "@material-ui/core";

export default function Component(props) {
	const { Input, formData, data, ...other } = props;

	return (
		<Grid item xs={12} sm={12}>
			<Input {...other} formData={formData} data={data} value={formData[data.id]} />
		</Grid>
	);
}
